import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/auth.store'
import { UserRole } from '@/types'
import { hasRole } from '@/utils/role'
import { ROUTES } from '@/constants'

interface ProtectedRouteProps {
  children: React.ReactNode
  allowedRoles?: UserRole[]
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
}) => {
  const { isAuthenticated, user } = useAuthStore()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  if (allowedRoles && user && !hasRole(user.role, allowedRoles)) {
    // Redirect to appropriate dashboard based on role
    const roleRoutes: Record<UserRole, string> = {
      [UserRole.ADMIN]: ROUTES.ADMIN.DASHBOARD,
      [UserRole.TEACHER]: ROUTES.TEACHER.DASHBOARD,
      [UserRole.STUDENT]: ROUTES.STUDENT.DASHBOARD,
      [UserRole.PARENT]: ROUTES.PARENT.DASHBOARD,
    }

    return <Navigate to={roleRoutes[user.role] || ROUTES.DASHBOARD} replace />
  }

  return <>{children}</>
}

